import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { loadStoredUser, NormalizedUser, storeUserSession, updateStoredUser } from '../utils/user-session';

@Injectable({ providedIn: 'root' })
export class UserSessionService {
  private userSubject = new BehaviorSubject<NormalizedUser | null>(loadStoredUser());
  readonly user$ = this.userSubject.asObservable();

  private refreshFromStorage(): NormalizedUser | null {
    const refreshed = loadStoredUser();
    this.userSubject.next(refreshed);
    return refreshed;
  }

  getUser(forceRefresh = false): NormalizedUser | null {
    if (forceRefresh) {
      return this.refreshFromStorage();
    }

    const current = this.userSubject.value;
    if (current) {
      return current;
    }

    return this.refreshFromStorage();
  }

  setUser(rawUser: any): NormalizedUser | null {
    const normalized = storeUserSession(rawUser);
    this.userSubject.next(normalized);
    return normalized;
  }

  patchUser(partial: Partial<NormalizedUser>): NormalizedUser | null {
    const updated = updateStoredUser(partial);
    this.userSubject.next(updated);
    return updated;
  }

  clear() {
    sessionStorage.removeItem('user');
    localStorage.removeItem('user');
    this.userSubject.next(null);
  }
}
